import { Link } from "react-router-dom";
import { MapPin, Phone, Mail, Clock, Instagram } from "lucide-react";

export default function Footer() {
  return (
    <footer className="border-t border-zinc-800 bg-[#131A2E]" data-testid="site-footer">
      <div className="px-6 md:px-12 py-16 md:py-24">
        <p className="font-display text-outline text-[22vw] md:text-[14rem] leading-none select-none text-center">
          OSC
        </p>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 mt-16">
          <div className="md:col-span-5">
            <p className="font-display text-2xl uppercase text-zinc-100">Okanagan Street Customs</p>
            <p className="text-zinc-500 text-sm mt-4 max-w-sm leading-relaxed">
              Collision repair and vehicle restoration done the right way — no shortcuts,
              no compromises. Quality work from the heart of the Okanagan.
            </p>
          </div>

          <div className="md:col-span-3">
            <p className="text-xs uppercase tracking-[0.3em] text-zinc-500 mb-5">Explore</p>
            <div className="flex flex-col gap-3 text-sm">
              <Link to="/#work" data-testid="footer-work-link" className="text-zinc-400 hover:text-[#E51B23] transition-colors">Our Work</Link>
              <Link to="/#contact" data-testid="footer-contact-link" className="text-zinc-400 hover:text-[#E51B23] transition-colors">Contact</Link>
              <Link to="/book" data-testid="footer-book-link" className="text-zinc-400 hover:text-[#E51B23] transition-colors">Book Appointment</Link>
              <Link to="/quote" data-testid="footer-quote-link" className="text-zinc-400 hover:text-[#E51B23] transition-colors">Free Estimate</Link>
              <Link to="/admin/login" data-testid="footer-admin-link" className="text-zinc-600 hover:text-zinc-400 transition-colors">Shop Login</Link>
            </div>
          </div>

          <div className="md:col-span-4">
            <p className="text-xs uppercase tracking-[0.3em] text-zinc-500 mb-5">Visit The Shop</p>
            <div className="flex flex-col gap-3 text-sm text-zinc-400">
              <span className="flex items-center gap-3"><MapPin size={15} className="text-[#E51B23]" /> 2323 Hunter Rd, Unit #7, Kelowna, BC</span>
              <span className="flex items-center gap-3"><Phone size={15} className="text-[#E51B23]" /> (250) 864-5030</span>
              <span className="flex items-center gap-3"><Mail size={15} className="text-[#E51B23]" /> okanaganstreetcustoms@gmail.com</span>
              <a href="https://www.instagram.com/okanaganstreetcustoms/" target="_blank" rel="noopener noreferrer" data-testid="footer-instagram-link" className="flex items-center gap-3 hover:text-[#E51B23] transition-colors"><Instagram size={15} className="text-[#E51B23]" /> @okanaganstreetcustoms</a>
              <span className="flex items-center gap-3"><Clock size={15} className="text-[#E51B23]" /> Mon – Fri, 8:00 AM – 5:30 PM</span>
            </div>
          </div>
        </div>

        <div className="border-t border-zinc-800 mt-16 pt-8 flex flex-col md:flex-row justify-between gap-4 text-xs text-zinc-600 uppercase tracking-[0.2em]">
          <span>© {new Date().getFullYear()} Okanagan Street Customs</span>
          <span>Built to be remembered</span>
        </div>
      </div>
    </footer>
  );
}
